module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"description_of_activity":"直近１ヶ月のACTIVITYを表示しています。","sanga":"さんが、","commented":"にコメントしました。","your_post":"あなたの投稿","your_favoraited_post":"あなたがいいね！した投稿"}}')
  delete Component.options._Ctor
}
